var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9557 20.373V14.4178C26.9557 7.83982 21.6232 2.50732 15.0452 2.50732V2.50732C8.46725 2.50732 3.13477 7.83982 3.13477 14.4178V32.5969",
    stroke: "#6C5DD3",
    strokeWidth: 5.01493,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0443 21.9404L15.0443 27.5822C15.0443 34.1602 20.3768 39.4927 26.9548 39.4927V39.4927C33.5327 39.4927 38.8652 34.1602 38.8652 27.5822L38.8652 9.40313",
    stroke: "#6C5DD3",
    strokeWidth: 5.01493,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50781 21.3135H39.4929",
    stroke: "#6C5DD3",
    strokeWidth: 5.01493
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.50746,
    y: 2.50746,
    width: 36.9851,
    height: 36.9851,
    rx: 10.0299,
    stroke: "#6C5DD3",
    strokeWidth: 5.01493
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecc964b0c33b2bc5a016491385b224be.svg";
export { ForwardRef as ReactComponent };